/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Extra_TimeInputs */



/**
* | output |
* | --- |
* | "extra" |
*
* @param {Timer_Extra_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_extra_time = /** @type {((inputs?: Timer_Extra_TimeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Extra_TimeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("supplémentaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("extra")
	if (locale === "pt") return /** @type {LocalizedString} */ ("extra")
	if (locale === "it") return /** @type {LocalizedString} */ ("extra")
	return /** @type {LocalizedString} */ ("extra")
});